export default () => ({
    list: []
})
